
class HXFormFieldTextAreaHTML extends HXFormField {

    static MAXLENGTH_UNLIMITED = 0; // Konstante fuer unbegrenzten Inhalt
    /** @private */
    inputObjEditor = null;

    constructor(inputName,formName) {
        super(inputName,formName);
        //aktuelle Bearbeitung findet in contenteditable div statt
        if (document.querySelectorAll("." + this.inputName + "Container .jqte_editor")[0]) {
                this.inputObjEditor = document.querySelectorAll("." + this.inputName + "Container .jqte_editor")[0];
        } else {
            //Im Readonly-Modus gibt es keinen jqte_editor - inhalt steht in div-Box
            this.inputObjEditor = this.inputObj;
        }
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {
            var value = ''+this.getValue();

            if (!this.getOptional() && value === '') {
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());
                this.validationPassed = false;

            } else if (value!=='' && value.length>hx.cint(this.getMaxLength()) && hx.cint(this.getMaxLength())!==HXFormFieldTextAreaHTML.MAXLENGTH_UNLIMITED) {
                this.validationMsg = hx.replace(this.formVars.dictLengthMsg, "#name#", this.getLabel());
                this.validationMsg = hx.replace(this.validationMsg, "#maxlength#", hx.cint(this.getMaxLength()));
                this.validationMsg = hx.replace(this.validationMsg, "#length#", value.length);
                this.validationPassed = false;
            }

            if (alertResult===true) super._validateFieldAlert(true,this.inputObjEditor);

        }
        return this.validationPassed;
    }

    /**
     * aktuelle Inhalte in contenteditable=true div
     * @return {string}
     */
    getValue() {
        return this.inputObjEditor.innerHTML;
    }

    /**
     * aktuelle Inhalte in contenteditable=true div
     * @param {string} value
     */
    setValue(value) {
        this.inputObjEditor.innerHTML = value;
    }

    /**
     * @returns {int}
     */
    getMaxLength() {
        return hx.cint(this.inputObj.getAttribute('data-hx-maxlength'));
    }

    /**
     * Maximal erlaubte max. Zeichen inkl. Formatierung im Eingabefeld
     * @param {int} maxLength
     */
    setMaxLength(maxLength) {
        this.inputObj.setAttribute('data-hx-maxlength', maxLength);
    }

    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional,'textareahtml');
    }

    /**
     * Link auf selektierten Teil setzten - wird von Medienpool aufgerufen
     * @param {string} link
     */
    setLinkOnSelectedText(link){
        var obj = $('div.' + this.inputName + 'Container');
        obj.find('.jqte_editor').trigger('openlinkarea');
        obj.find('.jqte_hxselect').first().val(0);
        obj.find('.jqte_linkinput').first().val(link);
        obj.find('.jqte_linkbutton').first().trigger('click');
    }


    /**
     *
     */
    displayInit(jqteCssHeight) {
        if (this.fieldExists()===true && this.getEditable()) {
            //JSON String muss doppelte anfuehrungszeichen enthalten
            var jqteSettingsStr = hx.replace(this.inputObj.getAttribute('data-hx-settings'), "'", "\"");
            //JSON -> JsObj
            var jqteSettingsObj = JSON.parse(jqteSettingsStr);
            //HTML Editor initialisieren
            $("textarea[name=" + this.inputName + "]").jqte(jqteSettingsObj);

            //Eingabebereich auf gewuenschte Hohe bringen (klappt nicht, da der Editor die CSS-Props des Elements auf P-Tags im Inhalt vererbt!)
            //$('.' + this.inputName + 'Container .jqte_editor').css('min-height', jqteCssHeight).css('max-height', jqteCssHeight);
            //$('.' + this.inputName + 'Container .jqte_source').css('min-height', jqteCssHeight).css('max-height', jqteCssHeight);

            $('.' + this.inputName + 'Container .jqte_editor').on("change",(event)=>{this.inputObj.dispatchEvent(new Event("change"))})

        }
    }

}